// <!-- theme dependencies -->
import './swipebox.css'
import './style5.css'
import './common.css'
import '../node_modules/ui-select/dist/select.css'

// <!-- theme css -->
import './themestyle.css'
import './chocolat.css'
import './flexslider.css'

// own css
import './app.css'



//////////////////
// WEBPACK FOOTER
// ./css/index.js
// module id = 0CPG
// module chunks = 18